import { theme } from '@approvalmax/theme';
import { Button, Text } from '@approvalmax/ui/src/components';
import styled from 'styled-components';

export const RemoveAllBillsButton = styled(Button)`
    text-decoration: underline;
    color: ${theme.color.red70};

    &:hover,
    &:focus {
        text-decoration: underline;
        color: ${theme.color.red70};
    }
`;

export const AmountValue = styled(Text)`
    font-size: 13px;
`;
